<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <ressource code="service-reference-choix-employeurs"></ressource>
      <v-checkbox
        class="list_counter_validator my-4 p-0"
        :input-value="hasEmployeursInscrits"
        :rules="[(v) => !!v || 'Veuillez sélectionner au moins un bureau.']"
      ></v-checkbox>
      <v-checkbox
        v-show="hasEmployeursInscrits"
        class="list_counter_validator my-4 p-0"
        :input-value="hasNombreEmployeursInscritsConforme"
        :rules="[(v) => !!v || `Veuillez sélectionner au moins ${sas.nombreEmploisReferencesInitial} bureau${sas.nombreEmploisReferencesInitial > 1 ? 'x' : ''}.`]"
      ></v-checkbox>
      <emplois-references
        :sas="sas"
        @service-reference-changed="onServiceReferenceChanged"
        :valids="validsEmploisReferences"
        ref="dataIterator_emploisReferences"
      ></emplois-references>
      <opq-case
        code="page-personnelle"
        v-model="sasServiceDeReference.sAbonnerALaPagePersonnelle"
        optional
        :live="liveSasServiceDeReference(3503)"
        :disabled="estAbonneALaPagePersonnelleInitial"
        @eudo-updated="pagePersonnelleCochee"
      ></opq-case>
      <template v-if="!hasEmploisReferencesInitials">
        <opq-text-field
          code="service-reference-courriel"
          is-email
          v-model="sasServiceDeReference.courrielServiceReference"
          :live="liveSasServiceDeReference(3504)"
          optional
        ></opq-text-field>
        <opq-catalogue
          code="service-reference-mandat"
          v-model="sasServiceDeReference.mandatsAcceptes"
          :live="liveSasServiceDeReference(3507)"
          optional
          multiple
        ></opq-catalogue>
        <div>
          <ressource code="information-accessibilite"></ressource>
        </div>
        <opq-case
          code="service-reference-intervention-domicile"
          v-model="sasServiceDeReference.interventionDomicile"
          :live="liveSasServiceDeReference(3508)"
          optional
        ></opq-case>
        <opq-case
          code="service-reference-modalites"
          v-model="sasServiceDeReference.modalitesServiceReference"
          :live="liveSasServiceDeReference(3510)"
        ></opq-case>
      </template>
      <v-checkbox
        class="list_counter_validator my-4 p-0"
        :input-value="montantPanierNEstPasZero"
        :rules="[(v) => !!v || getRessource('message-panier-zero')]"
      ></v-checkbox>
    </v-form>
  </div>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import RessourcesHelpers from "@/mixins/RessourcesHelpers"
import EmploisReferences from "./EmploisReferences"
import FormHybrid from "@/mixins/FormHybrid"
import { mapActions, mapGetters } from "vuex"

export default {
  mixins: [CataloguesHelper, RessourcesHelpers, FormHybrid],
  components: { EmploisReferences },
  props: {
    sas: { type: Object },
  },
  data() {
    return {
      validsEmploisReferences: []
    }
  },
  methods: {
    ...mapActions(["fetchPanier"]),
    liveSasServiceDeReference(cle) {
      return { endpoint: "sas-services-reference", cle: cle, fileId: this.sasServiceDeReference.id }
    },
    onServiceReferenceChanged(sasCarteDAffaire) {
      // Callback quand le service de référence change dans le composant EmploisReferences
      this.fetchPanier(this.sas.id)
    },
    pagePersonnelleCochee() {
      this.fetchPanier(this.sas.id)
    },
  },
  computed: {
    ...mapGetters(["panier"]),
    isValid() {
      return (
        this.valid && this.validsEmploisReferences.every((x) => x)
      )
    },
    sasServiceDeReference() {
      return this.sas.sasServiceDeReference
    },
    emploisReferencesActifs() {
      return this.sas?.emploisReferences?.filter((e) => e.serviceDeReferenceActif) ?? []
    },
    hasEmployeursInscrits() {
      return this.emploisReferencesActifs.length > 0
    },
    hasEmploisReferencesInitials() {
      return this.sas.nombreEmploisReferencesInitial > 0
    },
    hasNombreEmployeursInscritsConforme() {
      return this.emploisReferencesActifs.length >= this.sas.nombreEmploisReferencesInitial
    },
    estAbonneALaPagePersonnelleInitial() {
      return this.sas.sAbonnerALaPagePersonnelleInitial
    },
    montantPanierNEstPasZero() {
      return this.panier?.total?.prix && this.panier.total.prix > 0
    }
  },
  watch: {
    validsEmploisReferences() {
      this.$emit("validation-changed", this.isValid)
    },
  },
}
</script>

<style></style>
